var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeaderIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.012 42.2591L48.016 24L24.012 5.74097L0.00799561 24L24.012 42.2591Z",
    fill: "#E02229"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.012 35.782L8.39337 24.096L24.012 12.102L39.6306 24.096L24.012 35.782Z",
    fill: "#28141C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.012 30.4291L32.5614 24.284L24.012 17.5709L15.4666 24.28L24.012 30.4291Z",
    fill: "#FDF8ED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.012 0H0.0120239V5.74096H48.012V0Z",
    fill: "#E02229"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.012 42.259H0.0120239V48H48.012V42.259Z",
    fill: "#E02229"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderIcon);
export default __webpack_public_path__ + "static/media/HeaderIcon.cf2e9dbe01b5503118011a538a60cb54.svg";
export { ForwardRef as ReactComponent };